import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
  TextField,
  Button,
} from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

const ManufacturerCodeCreateDialog = ({
  open,
  manufacturerCode,
  error,
  onChange,
  onCancel,
  onAdd,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{ onClick: null }}
    >
      <DialogContent>
        <Typography variant="h6" color="primary">
          Add Manufacturer Code
        </Typography>

        <Divider style={{ marginTop: "16px", marginBottom: "16px" }} />

        <Typography variant="body2" gutterBottom>
          Manufacturer Code <span style={{ color: "red" }}>*</span>
        </Typography>

        <TextField
          fullWidth
          value={manufacturerCode}
          onChange={onChange}
          margin="dense"
          variant="outlined"
        />

        <Typography variant="caption" color="textSecondary">
          Allowed format: lowercase letters and numbers only <br />
          Example: samsung, apple, sony
        </Typography>

        {error && (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "6px",
              marginTop: "4px",
              color: "#d32f2f",
            }}
          >
            <ErrorOutlineIcon fontSize="small" style={{ marginTop: "2px" }} />

            <div style={{ whiteSpace: "pre-line", fontSize: "0.875rem" }}>
              {error}
            </div>
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>

        <Button color="primary" variant="contained" onClick={onAdd}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManufacturerCodeCreateDialog;
